export const eventType = {
  ACTIVITY: 'activity',
  CUSTOM: 'Custom Event',
  DBS: 'dbs',
  EMOTION: 'emotion',
  MEDICAL_EVENT: 'medical-event',
  MEDICATION: 'medication',
  MOOD: 'mood',
  NOTE: 'note',
  SUPPLEMENT: 'supplement',
  TAP_TEST: 'tap-test',
  WELLBEING: 'wellbeing',
}

export const duration = {
  DURATION: 'duration',
  ONGOING: 'ongoing',
}
